<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>多人预约</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="活动区域" prop="region">
        <el-cascader
              props.multiple = true v-model="ruleForm.region" :options="options" :props="cateProps" clearable> </el-cascader>
      </el-form-item>

      <!-- 多人预约统计 -->
      <el-form-item class="groups" label="成员登记" prop="group">
        <el-upload action="" :auto-upload="false" accept=".xlsx, .xls" :show-file-list="false" :on-change="handle">
          <el-button type="success">点击上传<i class="el-icon-thumb el-icon--right"></i></el-button>
        </el-upload>
        <el-button class="box" type="primary" @click="downloadTemplate">下载模板<i class="el-icon-download el-icon--right"></i></el-button>
        <a ref="downloadTemplate" style="display: none" href="./团体预约表.xlsx"></a>
      </el-form-item>

      <el-form-item label="预约邀请">
        <h3>湖州市平安实训基地暨吴兴平安实训学院:</h3>
        <p>兹有</p>
        <el-input placeholder="请输入单位名称" class="inputIntroduce" v-model="introduce"></el-input>
        <p>带领部分同志前往贵学院参观学习，目的是为了加强公共安全意识及提高实际公共安全应变处置操作能力，请贵学院予以接洽。</p>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :disabled="dasfgaggfsdxf" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cyuan" v-if="stringResuls">{{ stringResul }}</div>
  </div>
</template>

<script>
import Xlsx from 'xlsx'
export default {
  data() {
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
	  const regMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (regMobile.test(value)) {
         if(cb)
      		  return cb()
      		 return true
      }
      
      if(cb)
      		cb(new Error('请输入合法的手机号'))
      else{
		  console.log(new Error('请输入合法的手机号'));
      }
    }
    return {
      readers: [],
      stringResuls: false,
      dialogVisible: false,
      introduce: '',
      // 预约人数选择
      num: 1,
      activeIndex: '1',
      ruleForm: {
        name: '',
        region: [],
        mobile: '',
        // 名单
        group: [],
        // 介绍信
        introduce: '',
      },
      stringResul: '',
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' },
        ],
        region: [{ required: true, message: '请选择预约项目', trigger: 'change' }],
        mobile: [
          { required: true, message: '请输入手机', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
      },

      cateProps: { multiple: true, emitPath: false },
      
      options: [
        {
          value: 1,
          label: "全部预约",
          children: [
            {
              value: 2,
              label: "二楼",
              children: [
                { value: "xsss", label: "学生宿舍" },
                { value: "xyjws", label: "校园警务室" },
                { value: "xc", label: "校车安全" },
                { value: "jxl", label: "教学楼安全" },
                { value: "hxsys", label: "化学实验室" },
                { value: "sd", label: "书店" },
                { value: "wb", label: "网吧" }
                // { value: "yjjy", label: "应急救援" },
              ],
            },
            {
              value: 3,
              label: "三楼",
              children: [
                { value: 'wc', label: '重点车辆安全' },
                { value: 'kyz', label: '客运车安全' },
                { value: 'spxzf', label: '食品加工小作坊' },
                { value: 'cydcf', label: '餐饮店厨房' },
                { value: 'bmyd', label: '便民药店' },
                { value: 'bld', label: '便民超市' },
                { value: 'tzc', label: '童装厂' },
                { value: 'czw', label: '居住出租屋' },
                { value: 'yjaq', label: '寄递安全' }
          ]
            },
            {
              value: 4,
              label: "四楼",
               children: [
                { value: 'xj', label: '防范邪教' },
                { value: 'fank', label: '反恐防暴' },
                { value: 'jzsgaq', label: '建筑工地安全'},
                { value: 'dg', label: '施工用电安全' },
                { value: 'aqsc', label: '生产车间' },
                { value: 'tzsb', label: '特种设备' },
                { value: 'rq', label: '燃气安全' },
                { value: 'weih', label: '危化企业' },
                { value: 'gjaq', label: '国家安全' },
                { value: 'stzl', label: '生态治理' }
          ]
            },
          ],
        },
      ],
      valuess: '',
	  dasfgaggfsdxf: false
    }
  },
  created() {},
  mounted () {
    this.thiTime()
  },
  methods: {
    // 点击模板按钮触发a下载文件
    downloadTemplate() {
      this.$refs.downloadTemplate.dispatchEvent(new MouseEvent('click'))
    },
    async submitForm(formName) {
      this.ruleForm.introduce = `湖州市平安实训基地暨吴兴平安实训学院:兹有${this.introduce}带领部分同志前往贵学院参观学习，目的是为了加强公共安全意识及提高实际公共安全应变处置操作能力，请贵学院予以接洽。`

	  let validRes = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }
		validRes = true
      })
	  
	  if(!validRes) return false
	  
	  //表单验证成功，开始提交数据
	  this.dasfgaggfsdxf = true
      const data = await this.$http.post('group/establish', this.ruleForm)
      var pers = data.data.ops[0].group
      console.log(pers);
        const { data: res } = await this.$http.post('/examines/modify', {state: pers})
        console.log(res)
        if (res) {
          this.$message.success('注册成功等待管理员审核')
        }

      // this.stringResul = pers
      // this.stringResuls = true
      // setTimeout(() => {
      //   this.stringResuls = false
      // }, 10000)
      // const numbers = this.ruleForm.mobile
      // setTimeout(async () => {
      //   const {
      //     data: res
      //   } = await this.$http.post('sendmYYH', {
      //     numbers: numbers,
      //     number: this.stringResul
      //   })
      //   if (res) {
      //     this.$message.success('注册成功预约号已发送手机')
      //   }
      // }, 100)
	  
	  this.resetForm(formName)
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.num = 1
      this.introduce = ''
    },
    // downUp(){
    //     const jsonData = [{username:'测试',sex:'男',mobile:'13369869676',Company:'123',post:'123'}];
    //     if (!jsonData.length) return;
    //     // 表格的列标题 如果出现科学技术法或者其他格式 使用 \t
    //     let title = '姓名,性别,手机号,工作单位,职务\n';
    //     jsonData.map(item => {
    //       let key = {};
    //       key['姓名'] = item.username;
    //       key['性别'] = item.sex;
    //       key['手机号'] = item.mobile;
    //       key['工作单位'] = item.Company;
    //       key['职务'] = item.post;
    //       for (let i in key){
    //         title += `${key[i] + '\t'},`
    //       }
    //       title += '\n'
    //     });
    //     // encodeURIComponent 解决中文乱码
    //     let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(title);
    //     // 创建a标签
    //     let link = document.createElement('a');
    //     link.href = uri;
    //     link.download='预约模板下载.xls';
    //     link.click()
    //   },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => v[j]))
    // },
    // 1
    upload(file) {
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.readAsBinaryString(file)
        reader.onload = (ev) => {
          resolve(ev.target.result)
        }
      })
    },
    async handle(ev) {
      let file = ev.raw
      if (!file) return
      let reader = await this.upload(file)
      const worker = Xlsx.read(reader, { type: 'binary' })

      // 这个是将数据进行一步拼接
      worker.Sheets[worker.SheetNames[0]]

      // 将返回的数据转换为json对象的数据
      reader = Xlsx.utils.sheet_to_json(worker.Sheets[worker.SheetNames[0]])
      // 将读取出来的数据转换为可以发送给服务器的数据
      let KeyMp = {
        姓名: 'username',
        性别: 'sex',
        手机号: 'mobile',
        工作单位: 'Company',
        职务: 'post',
      }
      reader.forEach((item) => {
        let obj = Object.assign(item, {
          number: 0,
          fraction: 0,
          curriculum: [],
          type: 2,
          times: this.valuess
        })
        for (let key in obj) {
          let newKey = KeyMp[key]
          if (newKey) {
            obj[newKey] = obj[key]
            delete obj[key]
          }
        }
      })
      console.log(reader);
      this.ruleForm.group = reader
    },
    
    thiTime() {
			var aData = new Date();
			// console.log(aData) //Wed Aug 21 2019 10:00:58 GMT+0800 (中国标准时间)
			this.valuess =
				aData.getFullYear() + "年" + (aData.getMonth() + 1) + "月" + aData.getDate() + "日" + aData.getHours() + "：" + aData.getMinutes();
			console.log(this.valuess)
		}
  }
}
</script>

<style lang="less" scoped>
.el-form {
  margin-top: 3%;
  padding: 5%;
  background-color: #fff;
}
.el-input-number {
  margin-right: 4%;
}
.el-steps {
  margin-left: 4%;
}
.formgroup {
  margin-top: -5%;
  margin-left: 0;
}
/deep/.inputIntroduce input {
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
/deep/.el-step__head {
  display: none;
}
/deep/.el-step__title.is-success {
  color: #333;
}
/deep/.el-dialog__header {
  text-align: center;
}
.cyuan {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #999;
  font-size: 30px;
  width: 50%;
  text-align: center;
  height: 20%;
  z-index: 999;
  padding: 30px;
  padding-top: 40px;
  color: #fff;
  border-radius: 10px;
}
//下载按钮
.groups {
  position: relative;
}
.groups .box {
  position: absolute;
  top: 0px;
  left: 100px;
}
</style>